// @flow

import {combineReducers} from 'redux';

import {type KBActionType} from 'app/kbs/actions';

import {
  type RecordOfKBCategoryState,
  kbCategoriesReducer,
} from './kb-category-reducers';

import {
  type RecordOfKBQuestionState,
  kbQuestionsReducer,
} from './kb-question-reducers';

import {
  type RecordOfKnowledgebaseState,
  knowledgebaseReducer,
} from './knowledgebase-reducers';
import {
  articleFeedbackReducer,
  type RecordOfArticleFeedbackState,
} from './feedback-reducers';

export type KbStateShape = {
  knowledgebases: RecordOfKnowledgebaseState,
  categories: RecordOfKBCategoryState,
  questions: RecordOfKBQuestionState,
  feedback: RecordOfArticleFeedbackState,
};

export const kbReducer = combineReducers<
  {
    knowledgebases: typeof knowledgebaseReducer,
    categories: typeof kbCategoriesReducer,
    questions: typeof kbQuestionsReducer,
    feedback: typeof articleFeedbackReducer,
  },
  KBActionType
>({
  knowledgebases: knowledgebaseReducer,
  categories: kbCategoriesReducer,
  questions: kbQuestionsReducer,
  feedback: articleFeedbackReducer,
});
